import Cookies from "js-cookie";
import { Persister } from "@tanstack/react-query-persist-client";
import CryptoJS from "crypto-js";

export const COOKIE_OPTIONS = {
  path: "/",
  domain: ".lamtakam.com",
  expires: 365, // 1 year
};

export const setThemeCookie = (theme: string) => {
  Cookies.set("theme", theme, COOKIE_OPTIONS);
};

export const getThemeFromCookie = (): string | undefined => {
  return Cookies.get("theme");
};

export const clearPreferenceCookies = () => {
  Cookies.remove("theme", { path: "/", domain: ".lamtakam.com" });
};

export const testCookieFunctionality = () => {
  const testValue = "test-" + Date.now();
  Cookies.set("test", testValue, COOKIE_OPTIONS);
  const retrieved = Cookies.get("test");
  Cookies.remove("test", { path: "/", domain: ".lamtakam.com" });

  return {
    success: retrieved === testValue,
    message:
      retrieved === testValue
        ? "Cookies are working correctly"
        : "Cookie functionality test failed",
  };
};

export const syncStateWithCookies = (dispatch: any) => {
  // Sync theme
  const cookieTheme = getThemeFromCookie();
  if (cookieTheme) {
    import("../Store/modules/theme").then(({ setTheme }) => {
      dispatch(setTheme(cookieTheme as any));
    });
  }
};

export const setupCookieSyncListener = (dispatch: any) => {
  let lastTheme = getThemeFromCookie();

  const checkCookieChanges = () => {
    const currentTheme = getThemeFromCookie();

    if (currentTheme !== lastTheme) {
      lastTheme = currentTheme;
      if (currentTheme) {
        import("../Store/modules/theme").then(({ setTheme }) => {
          dispatch(setTheme(currentTheme as any));
        });
      }
    }
  };

  checkCookieChanges();

  const interval = setInterval(checkCookieChanges, 500);

  return () => clearInterval(interval);
};

export const setRequestFcmPermissionCookie = (status: "granted" | "skipped") => {
  if (status === "granted") {
    Cookies.set("fcm_permission", "granted", COOKIE_OPTIONS);
  } else if (status === "skipped") {
    Cookies.set("fcm_permission", "skipped", {
      ...COOKIE_OPTIONS,
      expires: 1,
    });
  }
};

export const getRequestFcmPermissionCookie = (): string | undefined => {
  return Cookies.get("fcm_permission");
};

export function createReactQueryLocalStoragePersister(): Persister {
  return {
    persistClient: (client) => {
      const item = {
        client,
        timestamp: Date.now(),
      };
      localStorage.setItem("rq-cache", JSON.stringify(item));
    },
    restoreClient: () => {
      const item = localStorage.getItem("rq-cache");
      if (!item) return undefined;

      const { client, timestamp } = JSON.parse(item);
      if (Date.now() - timestamp > 60 * 60 * 1000) return undefined; // 15 min expiry
      return client;
    },
    removeClient: () => localStorage.removeItem("rq-cache"),
  };
}

const AES_KEY = "AES_LTK_SECRET_KEY"; // بهتره از env بگیری

export function encrypt(value: string) {
  return CryptoJS.AES.encrypt(value, AES_KEY).toString();
}

export function decrypt(value: string) {
  try {
    const bytes = CryptoJS.AES.decrypt(value, AES_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return null;
  }
}
